import React from 'react';
import he from "he";
import clsx from "clsx";
import { useEffect, useState } from 'react';

const EasyCalEvent = ({ event, title, continuesPrior, continuesAfter, isAllDay, view, locationLookup }) => {

  const eventClass = clsx('rbc-event loc-'+event.location+' event-view-'+view, {
    'rbc-event-allday': isAllDay,
    'rbc-event-continues-prior': continuesPrior,
    'rbc-event-continues-after': continuesAfter,
  });
  
  let locationName = '';
  const bgImage       = {backgroundImage:`url('${event.image}')`}
  if(locationLookup)
    locationName  = locationLookup[event.location] || 'Unknown Location';


  let time  = event.start.toLocaleString('default', {hour: "numeric", minute: "numeric"});
  if(time === "12:00 AM") 
    time = ' ';
  const month = event.start.toLocaleString('default', { month: 'short' });
  const day   = event.start.toLocaleString('default', { weekday: 'short' });
  const longday = event.start.toLocaleString('default', { weekday: 'long' });
  const end   = event.end.toLocaleString('default', {hour: "numeric", minute: "numeric"});
  
  if(view == 'week') 
    return (
      <div className={eventClass}>
        <div className="rbc-event-content">
          {he.decode(title)}
          {/* <h6 className={`text loc-${event.location}`}>{time}</h6> */}
        </div>
      </div>
    )
  else if(view == 'tiles')
    return (
      <div className={eventClass}>
        <div className='ec-tile-top'>
          <div className={`date-box loc-${event.location}`}>
            <p className="date-text">{month}</p>
            <p className="date-num">{event.start.getDate()}</p>
            <p className="date-text">{day}</p>
          </div>
          <div className='ec-tile-info'>
            <h5 className='ec-tile-title'>{he.decode(event.title)}</h5>
            {event.noend && <h6 className={`text loc-${event.location}`}>{time}</h6>}
            {!event.noend && <h6 className={`text loc-${event.location}`}>{time} - {end}</h6>}
            <h5 className={`loc-text loc-${event.location}`}>{locationName}</h5>
          </div>
        </div>
        <img className="modal-img" src={event.image} />
      </div>
  ) 
  else if (view == 'agenda') 
    return (
    <div className={eventClass}>
      <div className='ec-agenda-event-wrapper'>
        <div className='ec-agenda-left date-box'>
          <h3 className="date-num">{event.start.getDate()}</h3>
          <h6 className='date-text'>{longday}</h6>
        </div>
        <div className='ec-agenda-right'>
          <h5 className='ec-agenda-title'>{event.title}</h5>
        </div>
      </div>
    </div>
  )
  else
    return (
      <div className={eventClass}>
        <div className="rbc-event-content">
          {he.decode(title)}
        </div>
      </div>
    );
};

export default EasyCalEvent;